import AxiosInstance from "@/components/Axios";
import { AxiosResponse } from "axios";

export async function get_files_in_folder(project_id: string, folder_name: string) {
    const response = await AxiosInstance.get(`api/afs/viewer/${project_id}/${folder_name}`)
    return response.data
}

export async function download_file(projectId: string, fileName: string): Promise<AxiosResponse> {
    try {
        // Set responseType to 'blob' to handle binary file data
        const response = await AxiosInstance.post(`/api/afs/download/file`, 
            { project_id: projectId, file_name: fileName },
            { responseType: 'blob' }
        )

        return response;
        
    } catch (error) {
        console.error('Error downloading file:', error);
        return Promise.reject(error);
    }
}

export async function delete_file(project_id: string, file_name: string) {
    const response = await AxiosInstance.delete(`/api/afs/delete/file`, {
        data: {
            project_id,
            file_name
        }
    })
    return response
}